import { Component, h, Host, Prop, State } from '@stencil/core';
import { WindowResizeService } from '../../services/window-resize-service';
import { ResponsiveBoolean, ResponsiveString } from '../../typings';
/**
 * @slot column1 - This will be column 1.
 * @slot column2 - This will be column 2.
 */
@Component({
  tag: 'content-split-block',
  styleUrl: 'content-split-block.scss',
  shadow: false,
})
export class ContentSplitBlock {
  /**
   * @type Boolean
   * @responsive
   */
  @Prop({
    mutable: true,
    reflect: true,
  })
  reverse: ResponsiveBoolean | boolean = false;
  /**
   * @type Number
   * @responsive
   */
  @Prop() columns: string = '1|2';
  /**
   * @type String
   * @responsive
   */
  @Prop({
    mutable: true,
    reflect: true,
  })
  classes: ResponsiveString;
  @State() classString;

  componentWillLoad() {
    WindowResizeService.registerProp(this.reverse).subscribe(newValue => (this.reverse = newValue as string));
    WindowResizeService.registerProp(this.classes).subscribe(newValue => (this.classString = newValue as string));
  }

  render() {
    return (
      <Host class={this.classString} reverse={this.reverse}>
        <content-grid-formatter type="flex" flex-grow="true" flex-shrink="true" columns={this.columns}>
          <slot name="column1"></slot>
          <slot name="column2"></slot>
        </content-grid-formatter>
      </Host>
    );
  }
}
